import { Component, Vue, Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';

import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import EditableTableColumn from '@/../bower_components/teknisavuecomponents/assets/interfaces/EditableTableColumn';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import Periodo from '@/../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import UtilPG from '@/assets/ts/utils/Util';
import GerenciarPermissoes from '@/components/GerenciarPermissoes/GerenciarPermissoes.vue';
import { ControleAcessoController } from '@/assets/ts/controller/ControleAcessoController';
import User from '@/assets/ts/interfaces/User';


@Component({
  name: 'ControleAcesso',
  components: {
    EditableTable,
    GerenciarPermissoes
  },
})
class ControleAcesso extends Vue {
  // #region [ STORE ]
  private get user(): User {
    return this.$store.getters.user;
  }

  private get periodoDemonstrativoAtual(): Periodo {
    return this.$store.getters.periodoDemonstrativoAtual;
  }

  private get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }

  private get idativacontroleacesso(): boolean {
    return this.$store.getters.user.idativacontroleacesso;
  }

  @Mutation('changeCurrentView')
  private changeCurrentView: (string) => void;
  // #endregion

  // #region [ DATA ]
  private readonly viewTitle = 'Controle de Acesso';

  private perfisAcesso: any[] = [];

  private loading = false;

  private gridSelected = [];
  private controleAcessoHabilitadoOriginal = this.idativacontroleacesso;
  private controleAcessoHabilitadoModel = this.idativacontroleacesso;
  private modalAtualizarStatusControleAcesso = false;

  private gerenciarPermissaoPopup = {
    open: false,
    row: null
  };

  private toolbarAdditionalActions = [];

  private rowSelected: any[] = [];

  private actions = [
    {
      label: 'Gerenciar Permissões',
      value: 'gerenciar',
      icon: 'mdi-pencil',
      mode: 'view',
      onClick: this.gerenciaPermissoesOnClick,
      condition: this.visibleConditionGerenciar
    },
  ];

  private columns: EditableTableColumn[] = [
    {
      text: 'Nr. Perfil Acesso',
      value: 'NRPERFILACESSO',
      type: 'text',
      textAlign: 'center'
    },
    {
      text: 'Perfil Acesso',
      value: 'NMPERFILACESSO',
      type: 'text',
    },
    {
      text: 'Perfil Acesso ADM',
      value: 'NMIDPERFILACESSOADM',
      type: 'text',
    },
  ];

  private toolbarActions: ToolbarAction[] = [
    {
      name: 'reload',
      label: 'Atualizar',
      showLabel: true,
      icon: 'mdi-refresh',
      onClick: this.reload,
    },
    {
      name: 'atualizar-status',
      label: 'Ativar/Desativar Controle de Acesso',
      showLabel: true,
      icon: 'mdi-lock',
      onClick: this.openModalAtualizaStatusControleAcesso,
    }
  ];
  // #endregion

  // #region [ COMPUTED ]
  private get filtersAreSelected(): boolean {
    const areSelected =
      !Util.isUndefinedOrNull(this.estruturaGerencialAtual) &&
      !Util.isUndefinedOrNull(this.periodoDemonstrativoAtual);

    return areSelected;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private async created() {
    this.changeCurrentView(this.viewTitle);
    (window as any).perfisAcesso = this;
  }

  private mounted() {
    this.reload();
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('estruturaGerencialAtual')
  private estruturaOnChange() {
    this.reload();
  }

  @Watch('periodoDemonstrativoAtual')
  private periodoOnChange() {
    this.reload();
  }
  // #endregion

  get statusTitleControleAcesso() {
    return this.controleAcessoHabilitadoOriginal ? 'Desabilitar Controle de Acesso' : 'Habilitar Controle de Acesso';
  }

  get iconControleAcesso() {
    return this.controleAcessoHabilitadoOriginal ? 'mdi-lock-open' : 'mdi-lock';
  }

  // #region [ METHODS ]
  private async reload() {
    this.loading = true;
    this.perfisAcesso = [];

    try {
      const perfisAcesso = await ControleAcessoController.getPerfisAcessoControle();

      this.perfisAcesso = perfisAcesso;
    } catch (err) {
    } finally {
      this.loading = false;
    }
  }
  
  private gerenciarPermissoesAfterSave() {
    this.reload();
  }

  private visibleConditionGerenciar(row: { IDSINCRONIZADO: string }) {
    return this.user.dp;
  }

  private gerenciaPermissoesOnClick(row: any) {
    this.rowSelected = row;
    this.gerenciarPermissaoPopup = { open: true, row};
  }

  private async openModalAtualizaStatusControleAcesso() {
    const status = await ControleAcessoController.getStatusControleAcesso();
    this.controleAcessoHabilitadoOriginal = status == UtilPG.ID_TRUE;

    this.controleAcessoHabilitadoModel = status == UtilPG.ID_TRUE;
    this.modalAtualizarStatusControleAcesso = true;
  }

  private async atualizarStatusControleAcesso() {
    this.loading = true;

    try {
      const status = this.controleAcessoHabilitadoModel ? "S" : "N";

      await ControleAcessoController.atualizarStatusControleAcesso(status);
      this.controleAcessoHabilitadoOriginal = this.controleAcessoHabilitadoModel;;

      this.modalAtualizarStatusControleAcesso = false;
    } catch (err) {
    } finally {
      this.loading = false;
    }

  }

}

export default ControleAcesso;